export const StudentAvailability = ({
  availability,
  setAvailability,
  readOnly,
}) => {
  // const [availability, setAvailability] = useState(
  //   daysOfWeek.map((day) => ({
  //     day,
  //     available: false,
  //     from: "15:00",
  //     to: "20:00",
  //   }))
  // );

  const handleCheckboxChange = (index) => {
    if (readOnly === true) {
      return;
    }
    // const newAvailability = availability.filter((availability) => {
    //   return availability.NotAvailable === false;
    // });
    const newAvailability = [...availability];
    newAvailability[index].available = !newAvailability[index].available;

    setAvailability(newAvailability);
  };

  const handleTimeChange = (index, field, value) => {
    if (readOnly === true) {
      return;
    }
    const [hours, minutes] = value.split(":").map(Number);

    // Ensure time is between 07:00 (7 AM) and 19:00 (7 PM)
    if (hours < 7 || hours > 19) {
      alert("Please select a time between 07:00 AM and 07:00 PM.");
      return;
    }
    const newAvailability = [...availability];
    newAvailability[index][field] = value;
    setAvailability(newAvailability);
  };

  const handleSubmit = async () => {
    try {
      //   await axios.post('/api/availability', { availability });
      //   await fetch("/api/availability", { availability });
      // console.log(availability);
      alert("Availability saved successfully!");
    } catch (error) {
      console.error("Error saving availability", error);
      alert("Failed to save availability");
    }
  };

  return (
    <div>
      <p className="fs-5">
        {readOnly ? "Availability" : "Select Your Availability"}
      </p>
      {availability.map((slot, index) => (
        <div key={index} style={{ marginBottom: "10px" }}>
          <label>
            <input
              type="checkbox"
              className="instructor-input-field mx-2"
              checked={slot.available}
              onChange={() => handleCheckboxChange(index)}
            />
            {slot.day}
            {/* {slot.day} NotAvailable */}
          </label>
          <div className="flex">
            <div className="justify-content-center">
              from:
              <input
                type="time"
                className="instructor-input-field p-2 mx-2"
                value={slot.from}
                disabled={!slot.available}
                min="07:00"
                max="19:00"
                onChange={(e) =>
                  handleTimeChange(index, "from", e.target.value)
                }
              />
            </div>
            <div className="justify-content-center">
              to:
              <input
                type="time"
                className="instructor-input-field p-2 mx-2"
                value={slot.to}
                disabled={!slot.available}
                min="07:00"
                max="19:00"
                onChange={(e) => handleTimeChange(index, "to", e.target.value)}
              />
            </div>
          </div>
        </div>
      ))}
      {/* <button onClick={handleSubmit}>Save Availability</button> */}
    </div>
  );
};
